import React from "react";
import ReactApexChart from "react-apexcharts";
import useWindowDimensions from "../../utils/useWindowDimensions";

const UsersRadial = ({ activeUsers, newVisitors, inActiveUsers }) => {
  const { width } = useWindowDimensions();

  const chartData = {
    series: [activeUsers, inActiveUsers, newVisitors],
    options: {
      chart: {
        type: "radialBar",
      },
      plotOptions: {
        radialBar: {
          offsetY: width > 1500 ? 20 : 10,
          startAngle: 0,
          endAngle: 270,
          hollow: {
            margin: 35,
            size: width > 1500 ? "45%" : "20%",
            background: "transparent",
            image: undefined,
          },
          dataLabels: {
            name: {
              show: false,
            },
            value: {
              show: false,
            },
          },
          barLabels: {
            enabled: true,
            useSeriesColors: true,
            margin: 15,
            fontSize: width > 1500 ? "12.5px" : "11px",
            fontFamily: "Poppins, sans-serif",
            formatter: function (seriesName, opts) {
              return seriesName + ":  " + opts.w.globals.series[opts.seriesIndex];
            },
          },
        },
      },
      colors: ["#CA353B", "#3c3972", "#333333"],
      labels: ["Active", "Inactive", "New"],
      responsive: [
        {
          breakpoint: 480,
          options: {
            legend: {
              show: false,
            },
          },
        },
      ],
    },
  };

  return (
    <div id="card" className="combined-userchart">
      <div id="chart">
        <ReactApexChart
          options={chartData.options}
          series={chartData.series}
          type="radialBar"
          height={width > 1400 && width < 1700 ? 253 : width >= 1700 ? 295 : 210}
        />
      </div>
      <div id="html-dist"></div>
    </div>
  );
};

export default UsersRadial;
